// removed by extract-text-webpack-plugin
module.exports = {"BackgroundBox":"_2jTBh","BackgroundBoxOne":"_v-nw6","BackgroundBoxTwo":"_3Wt3u","BackgroundBoxThree":"_965zN"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Flight/Tuple/TupleInner/FlightInfo/FlightInfoLayover/InfoLayoverTag/InfoLayoverTag.scss
// module id = 520
// module chunks = 0